import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { userListEditModal } from '../../../validation/yupSchema';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { callAdminUpdateUser } from '../../../api-services/index';

const UserEditModal = ({
  openEditModal,
  setOpenEditModal,
  modalData,
  setModalData,
}) => {
  const queryClient = useQueryClient();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(userListEditModal),
    mode: 'onSubmit',
  });

  const { isLoading, mutateAsync } = useMutation(
    'update-user',
    callAdminUpdateUser,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: 'Error!',
          text: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const submitEditedUser = async (value) => {
    let payload = {
      uuid: modalData.uuid,
      name: value.name,
      phone: value.phone,
      action_type: 'update',
    };
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (modalData && Object.keys(modalData).length > 0) {
      reset({
        name: modalData?.name,
        phone: modalData?.phone,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData]);

  const handleClose = () => {
    setOpenEditModal(false);
    setModalData({});
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={openEditModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Edit User</h5>
        </div>
        <div className="body-content-outer modal-body">
          <div className="col-md-12">
            <form
              className="m-0 form-fields"
              onSubmit={handleSubmit(submitEditedUser)}
            >
              <div className="form-group">
                <input
                  {...register('name')}
                  type="text"
                  name="name"
                  maxLength="25"
                  placeholder="Name"
                  className="form-control"
                />
                <p>{errors.name?.message}</p>
              </div>

              <div className="form-group">
                <input
                  {...register('email')}
                  type="email"
                  name="email"
                  value={modalData.email}
                  placeholder="Email"
                  className="form-control"
                  disabled
                />
              </div>

              <div className="form-group">
                <input
                  {...register('phone')}
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  className="form-control"
                />
                <p>{errors.phone?.message}</p>
              </div>

              <div className="form-group text-center mt-4">
                <button type="submit" className="btn btn-dark-blue">
                  {isLoading ? 'loading' : 'Update'}
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleClose()}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserEditModal;
